import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Button, Grid, Loader, Dimmer } from 'semantic-ui-react';
import Swal from 'sweetalert2';
import axiosInstance from '../../helpers/axiosInstance';
import { ForgotPasswordModel } from '../../types/UserDTO';
import logo from "../../assets/images/login-logo.png";

type FormErrorFields = {
  email: string;
};

export const ForgotPasswordForm: React.FC = () => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [formValues, setFormValues] = useState<ForgotPasswordModel>({} as ForgotPasswordModel);
  const [formErrors, setFormErrors] = useState<FormErrorFields>({
    email: ''
  });

  useEffect(() => {
    document.title = 'Forgot Password - Adjure';
  }, []);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    validate(false, name, value);
  };

  const validate = async (validateAll: boolean, fieldName: string | null = null, value: any | null = null): Promise<FormErrorFields> => {
    return await new Promise((resolve, reject) => {
      let errors: FormErrorFields = { ...formErrors };
      try {
        if (validateAll) {
          errors = {
            email: !formValues?.email ? 'Email is required' : '',
          };
        } else {
          switch (fieldName) {
            case 'email':
              errors.email = !value ? 'Email is required' : '';
              break;
            default:
              break;
          }
        }
        setFormErrors(errors);
        resolve(errors);
      } catch (error) {
        console.log(`Validation error`);
        reject(errors);
      }
    });
  }

  const handleSubmit = async () => {
    const errors = await validate(true);
    const hasErrors = Object.values(errors).some((error) => error);
    if (!hasErrors) {
      // handle form submission 
      let payload = {};
      setIsLoading(true);
      axiosInstance.post(`/Auth/ForgotPassword/${formValues.email}`, payload).then(({ data, status, statusText }) => {
        setIsLoading(false);
        if (status === 200) {
          Swal.fire({
            title: 'Email has been sent to reset the password',
            icon: 'success',
            confirmButtonText: 'Ok',
            showConfirmButton: true,
            showDenyButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false
          }).then((result) => {
            if (result.isConfirmed) {
              navigate('/login');
            }
          });
        }
      })
        .catch((error) => {
          setIsLoading(false);
        });
    }
  };

  return (
    <Dimmer.Dimmable as="div" dimmed={isLoading}>
      <Dimmer active={isLoading} inverted={true}>
        <Loader>Loading</Loader>
      </Dimmer>
      <Grid textAlign="center" verticalAlign="middle" style={{ height: '100vh' }}>
        <Grid.Row>
          <Grid.Column>
            <div style={{ maxWidth: '320px', margin: '0 auto' }}>
              <img src={logo} alt="Adjure CRM" />
              <Form className='form-custom'>
                <h2 style={{ marginTop: '1rem' }}>Forgot Password</h2>
                <Form.Group inline style={{ marginTop: '2rem', marginBottom: '2rem' }}>
                  <Form.Field style={{ textAlign: 'left' }}>
                    <Form.Input
                      type="text"
                      label="Email"
                      name="email"
                      value={formValues.email}
                      onChange={handleInputChange}
                      onBlur={handleBlur}
                      error={!!formErrors?.email}
                      required
                    />
                    {formErrors?.email && <div className="error-message" style={{ color: 'red', textAlign: 'left', marginLeft: '6.5rem' }}>{formErrors?.email}</div>}
                  </Form.Field>
                </Form.Group>
                <Grid style={{ marginBottom: '1rem' }}>
                  <Grid.Column>
                    <Button type="button" className='second button' style={{ padding: '1.1rem 2.1rem', borderRadius: '0rem', color: 'white', fontSize: '1.6rem' }} onClick={() => navigate('/login')}>
                      Cancel
                    </Button>
                    <Button type="submit" onClick={handleSubmit} className='violet button' style={{ padding: '1.1rem 2.1rem', borderRadius: '0rem', fontSize: '1.6rem' }}>
                      Submit
                    </Button>
                  </Grid.Column>
                </Grid>
              </Form>
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Dimmer.Dimmable>
  );
}

export default ForgotPasswordForm;